// extracted by mini-css-extract-plugin
export var actions = "_qt-4";
export var item = "_qt-1";
export var price = "_qt-3";
export var quantity = "_qt-2";
export var table = "_qt-0";